import { EyeIcon, EyeSlashIcon } from "@heroicons/react/16/solid";
import { useState } from "react";
import { handlePasswordChange } from "@services/ErrorHandling";
import { UserFieldErrorMessages } from "@constants/Errors";

interface PasswordItemProps {
  label: string;
  identifier: string;
  password: string;
  errors: boolean;
  modal: boolean;
  setError: (field: string, value: boolean) => void;
  setPassword: (password: string) => void;
}

const PasswordItem: React.FC<PasswordItemProps> = ({
  label,
  password,
  identifier,
  setError,
  errors,
  modal,
  setPassword,
}) => {
  const [showPassword, setShowPassword] = useState<boolean>(false);

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const verifyPassword = (value: string) => {
    handlePasswordChange(identifier, value, setPassword, setError);
  };

  return (
    <div className="password-item">
      <label className="mb-2.5 block font-medium text-mayo-light-gray">
        {label}
      </label>
      <div
        className={`relative inline-flex ${
          modal ? "password-textbox-modal" : "password-textbox"
        }`}
      >
        <input
          type={showPassword ? "text" : "password"}
          value={password || ""}
          required
          onChange={(e) => verifyPassword(e.target.value)}
          className="w-full h-full bg-transparent outline-none pr-8"
        />
        <button
          type="button"
          className="absolute inset-y-0 right-0 flex items-center pr-2 text-gray-400 hover:text-gray-600"
          onClick={toggleShowPassword}
        >
          {showPassword ? (
            <EyeSlashIcon className="w-5 h-5" />
          ) : (
            <EyeIcon className="w-5 h-5" />
          )}
        </button>
      </div>
      {errors && (
        <p className="text-red-500 mt-2">
          {UserFieldErrorMessages.passwordError}
        </p>
      )}
    </div>
  );
};

export default PasswordItem;
